export default {
      id: "documents-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#documents",
      toString: function () {
        return this.url;
      }
    }